module.exports = __webpack_public_path__ + "media/images/menu/microscopium-ef87ff849e03907de28e83b3e3fe899d.jpg";